/* global translation */

const hideUnselectedBundleItems = () => {
  const productBundles = Array.from(document.querySelectorAll('table.order_details tbody tr.order_item > td.change_item > input[name*=add_to_order_product]'));
  productBundles.forEach((bundleItemCheckbox) => {
    if (!bundleItemCheckbox.checked && bundleItemCheckbox.type === 'checkbox') {
      bundleItemCheckbox.parentNode.parentNode.remove();
    }

    if (bundleItemCheckbox.checked) {
      // eslint-disable-next-line no-param-reassign
      bundleItemCheckbox.disabled = 'disabled';
    }
  });
};

const maybeInsertRemoveForVIP = () => {
  const productBundleParents = Array.from(document.querySelectorAll('table.order_details tbody tr.bundle-parent'));
  if (productBundleParents && productBundleParents.length >= 2) {
    productBundleParents.forEach((row) => {
      const changeButton = row.querySelector('.button');
      const removeButton = document.createElement('a');
      removeButton.classList.add('remove-package');
      removeButton.href = '#';
      removeButton.innerText = translation.remove_package;
      removeButton.style.marginLeft = '10px';
      removeButton.dataset.itemId = row.dataset.itemId;
      removeButton.dataset.subscriptionId = row.dataset.subscriptionId;
      changeButton.parentNode.insertBefore(removeButton, changeButton);

      removeButton.addEventListener('click', (event) => {
        event.preventDefault();
        document.body.classList.add('wait');

        const payload = {
          action: 'maksimer_remove_bundle_from_subscription',
          item_id: removeButton.dataset.itemId,
          subscription_id: removeButton.dataset.subscriptionId,
        };

        jQuery.post(translation.ajaxurl, payload, () => {
          // eslint-disable-next-line no-restricted-globals
          location.reload();
        });
      });
    });
  }
};

const addBundle = () => {
  const productBundles = Array.from(document.querySelectorAll('#add-bundle .extra-subscription-products > .product:not(.bundled-product)'));

  productBundles.forEach((bundleProductLine) => {
    const toggleButton = bundleProductLine.querySelector('a.button');
    const bundleOptions = bundleProductLine.querySelector('.extra-subscription-products-wrapper');
    const confirmButton = bundleProductLine.querySelector('.confirm-package-change');
    toggleButton.addEventListener('click', (event) => {
      event.preventDefault();
      bundleOptions.classList.toggle('closed');
    });

    confirmButton.addEventListener('click', (event) => {
      event.preventDefault();
      const { subscriptionId, bundleId } = confirmButton.dataset;
      const selectedItems = bundleProductLine.querySelectorAll('input.bundled_product_checkbox:checked');
      const selectedItemIds = [];

      document.body.classList.add('wait');

      selectedItems.forEach((item) => {
        selectedItemIds.push(item.value);
      });

      const payload = {
        action: 'maksimer_add_product_bundle_to_subscription',
        bundle_id: bundleId,
        subscription_id: subscriptionId,
        item_ids: selectedItemIds,
      };

      jQuery.post(translation.ajaxurl, payload, (response) => {
        if (response.success) {
          // eslint-disable-next-line no-restricted-globals
          location.reload();
        } else {
          document.body.classList.remove('wait');
          alert(response.data.error);
        }
      });
    });
  });
};

const changeBundle = () => {
  const productBundles = Array.from(document.querySelectorAll('.popup.change-existing-bundle'));

  productBundles.forEach((bundleProductLine) => {
    const confirmButton = bundleProductLine.querySelector('.confirm-package-change');

    confirmButton.addEventListener('click', (event) => {
      event.preventDefault();
      const { subscriptionId, bundleId, itemId } = confirmButton.dataset;
      const selectedItems = bundleProductLine.querySelectorAll('input[name*=add_to_order_product]:checked');
      const selectedItemIds = [];

      document.body.classList.add('wait');

      selectedItems.forEach((item) => {
        selectedItemIds.push(item.value);
      });

      const payload = {
        action: 'maksimer_add_product_bundle_to_subscription',
        item_id: itemId,
        bundle_id: bundleId,
        subscription_id: subscriptionId,
        item_ids: selectedItemIds,
      };

      jQuery.post(translation.ajaxurl, payload, (response) => {
        if (response.success) {
          // eslint-disable-next-line no-restricted-globals
          location.reload();
        } else {
          document.body.classList.remove('wait');
          alert(response.data.error);
        }
      });
    });
  });
};

const addProductToSubscription = () => {
  const buttons = Array.from(document.getElementsByClassName('add-product-to-subscription'));

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const { productId, subscriptionId } = button.dataset;
      document.body.classList.add('wait');
      const payload = {
        action: 'maksimer_add_product_to_subscription',
        product_id: productId,
        subscription_id: subscriptionId,
      };

      jQuery.post(translation.ajaxurl, payload, () => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      });
    });
  });
};

const removeProductFromSubscription = () => {
  const removeButtons = document.querySelectorAll('.remove-item-from-subscription');

  removeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      // eslint-disable-next-line no-restricted-globals
      if (confirm('Slette produktet?')) {
        document.body.classList.add('wait');
        const { subscriptionId, itemId } = button.dataset;

        const payload = {
          action: 'maksimer_remove_product_to_subscription',
          subscription_id: subscriptionId,
          item_id: itemId,
        };

        jQuery.post(translation.ajaxurl, payload, () => {
          // eslint-disable-next-line no-restricted-globals
          location.reload();
        });
      }
    });
  });
};

if (document.body.classList.contains('woocommerce-view-subscription')) {
  hideUnselectedBundleItems();
  maybeInsertRemoveForVIP();
  addProductToSubscription();
  removeProductFromSubscription();
  addBundle();
  changeBundle();
}
